{
  "permissions": {
    "operations.self": "Clock in/out and see own queue readiness",
    "operations.view": "View assigned operations groups, reports and alerts",
    "operations.configure": "Configure operations, Slack, Zoho and service hours (administrator)",
    "operations.clear": "Verify and clear individual PBX channels (technical staff)",
    "knowledge.author": "Create and revise local hotel knowledge (Data Entry)",
    "knowledge.publish": "Publish reviewed hotel knowledge",
    "mail.qa": "Review blind mail quality samples",
    "mail.reports": "View scoped mail volumes and quality reports",
    "mail.view": "Read assigned hotel mailboxes",
    "mail.edit": "Claim emails, prepare and edit replies",
    "mail.approve": "Approve saved email replies",
    "mail.send": "Explicitly send approved email replies",
    "coaching.use": "Take explicitly assigned coaching and quizzes",
    "coaching.manage": "Create coaching, assign scoped agents and review scores (supervisors/admins)",
    "sms.use": "Read and send SMS from assigned telephone numbers",
    "sms.manage": "Configure SMS providers and telephone number assignments (administrator)",
    "workflow.manage": "Configure phone book, dispositions, prefixes and supervisors (administrator)",
    "knowledge.view": "Read scoped property and customer FAQs",
    "knowledge.manage": "Manage scoped FAQs and property photos (supervisors/admins)",
    "monitor.global": "Monitor all queues and team calls (supervisors/admins)",
    "monitor.whisper": "Listen and talk privately to the agent",
    "calls.hold": "Request hold/resume on an agent browser phone",
    "calls.reroute": "Reroute caller to an approved queue",
    "summaries.use": "Request and view call summaries",
    "integrations.manage": "Configure summary providers (administrator)",
    "phone.use": "Use the built-in softphone",
    "queues.view": "View assigned queues and operator status",
    "queues.self": "Join, leave, pause and resume own queues",
    "queues.manage": "Pause/resume other members in assigned queues",
    "calls.team": "View team calls and history in assigned queues",
    "history.view": "View call history",
    "notes.write": "Add call notes and dispositions",
    "recordings.play": "Listen to authorized recordings",
    "recordings.control": "Start and mute own workspace recordings",
    "monitor.listen": "Listen to team calls in assigned queues",
    "customers.view": "View customer directory",
    "customers.edit": "Create and edit scoped customer records",
    "properties.edit": "Create and edit scoped property records",
    "cms.import": "Import CMS data (administrator)",
    "users.manage": "Manage users and access (administrator)",
    "ldap.manage": "Configure and test LDAP (administrator)",
    "audit.view": "View global activity audit (administrator)"
  },
  "presets": {
    "agent": [
      "coaching.use",
      "customers.view",
      "history.view",
      "knowledge.view",
      "mail.edit",
      "mail.view",
      "notes.write",
      "operations.self",
      "phone.use",
      "queues.self",
      "queues.view",
      "recordings.control",
      "recordings.play",
      "sms.use",
      "summaries.use"
    ],
    "manager": [
      "calls.hold",
      "calls.reroute",
      "calls.team",
      "coaching.manage",
      "coaching.use",
      "customers.edit",
      "customers.view",
      "history.view",
      "knowledge.author",
      "knowledge.manage",
      "knowledge.publish",
      "knowledge.view",
      "mail.approve",
      "mail.edit",
      "mail.qa",
      "mail.reports",
      "mail.send",
      "mail.view",
      "monitor.listen",
      "monitor.whisper",
      "notes.write",
      "operations.self",
      "operations.view",
      "phone.use",
      "properties.edit",
      "queues.manage",
      "queues.self",
      "queues.view",
      "recordings.control",
      "recordings.play",
      "sms.use",
      "summaries.use"
    ],
    "admin": [
      "audit.view",
      "calls.hold",
      "calls.reroute",
      "calls.team",
      "cms.import",
      "coaching.manage",
      "coaching.use",
      "customers.edit",
      "customers.view",
      "history.view",
      "integrations.manage",
      "knowledge.author",
      "knowledge.manage",
      "knowledge.publish",
      "knowledge.view",
      "ldap.manage",
      "mail.approve",
      "mail.edit",
      "mail.qa",
      "mail.reports",
      "mail.send",
      "mail.view",
      "monitor.global",
      "monitor.listen",
      "monitor.whisper",
      "notes.write",
      "operations.clear",
      "operations.configure",
      "operations.self",
      "operations.view",
      "phone.use",
      "properties.edit",
      "queues.manage",
      "queues.self",
      "queues.view",
      "recordings.control",
      "recordings.play",
      "sms.manage",
      "sms.use",
      "summaries.use",
      "users.manage",
      "workflow.manage"
    ]
  },
  "admin_only": [
    "audit.view",
    "cms.import",
    "integrations.manage",
    "ldap.manage",
    "operations.configure",
    "sms.manage",
    "users.manage",
    "workflow.manage"
  ]
}
